import { render, staticRenderFns } from "./zhuanzhu.vue?vue&type=template&id=50a5a4c9&scoped=true&"
import script from "./zhuanzhu.vue?vue&type=script&lang=js&"
export * from "./zhuanzhu.vue?vue&type=script&lang=js&"
import style0 from "./zhuanzhu.vue?vue&type=style&index=0&lang=css&"
import style1 from "./zhuanzhu.vue?vue&type=style&index=1&id=50a5a4c9&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a5a4c9",
  null
  
)

export default component.exports